const isNumeroDecimal = (value: string): boolean => /^\d+(\.\d{1,2})?$/.test(value);

export default isNumeroDecimal;
